"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import styles from "./graph-context-message.module.scss";
type GraphContextMessageProps = {
  date: string;
  airtime: string;
  shareOfAirtime: string;
  className?: string;
};

/** Figma 227:3429 — graph hover context message */
export function GraphContextMessage(t0) {
  const $ = _c(20);
  const {
    date,
    airtime,
    shareOfAirtime,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn(styles.root, className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== date) {
    t2 = <div className={styles.dateRow}><p className={styles.date}>{date}</p></div>;
    $[2] = date;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={styles.divider} />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className={styles.dotAirtime} aria-hidden={true} />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className={styles.metricLabel}>Airtime</span>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== airtime) {
    t6 = <div className={styles.metricRow}>{t4}<div className={styles.metricContent}>{t5}<span className={styles.metricValue}>{airtime}</span></div></div>;
    $[7] = airtime;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span className={styles.dotShare} aria-hidden={true} />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className={styles.metricLabel}>Share Of Airtime</span>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== shareOfAirtime) {
    t9 = <div className={styles.metricRow}>{t7}<div className={styles.metricContent}>{t8}<span className={styles.metricValue}>{shareOfAirtime}</span></div></div>;
    $[11] = shareOfAirtime;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t6 || $[14] !== t9) {
    t10 = <div className={styles.metrics}>{t6}{t9}</div>;
    $[13] = t6;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t1 || $[17] !== t10 || $[18] !== t2) {
    t11 = <div className={t1} data-node-id="227:3429">{t2}{t3}{t10}</div>;
    $[16] = t1;
    $[17] = t10;
    $[18] = t2;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
}